module.exports = __webpack_public_path__ + "img/bannerBg.c44fda3f.png";